import { Stack, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import UserFormField from '../../User/UserFormField'
import {
    DEFAULT_ERROR_MESSAGE,
    FINESS_ERROR_MESSAGE,
    FINESS_TOOLTIP_TITLE,
    useFormContextRequester,
} from '../utils/_utils'
import { FinessTooltipHelperImage } from '../../../assets/images/image'
import sxs from '../_sxs'

const FinessNum = () => {
    const { control } = useFormContextRequester()

    return (
        <Controller
            control={control}
            name="finessNum"
            rules={{
                required: DEFAULT_ERROR_MESSAGE,
                pattern: {
                    value: /^(?:\d{9}|\d[AB]\d{7})$/,
                    message: FINESS_ERROR_MESSAGE,
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    required
                    variant="input"
                    label="Numéro FINESS"
                    placeholder="0 0 0 0 0 0 0 0 0"
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    sideTooltip={
                        <Stack sx={sxs.tooltipContainer}>
                            <Typography flex={2}>{FINESS_TOOLTIP_TITLE}</Typography>
                            <FinessTooltipHelperImage style={{ flexShrink: 1 }} />
                        </Stack>
                    }
                    {...field}
                    inputProps={{
                        maxLength: 9,
                    }}
                    value={field?.value ?? ''}
                />
            )}
        />
    )
}

export default FinessNum
